<template>
  <v-container
    fluid
    grid-list-md
  >
    <h1 class="text-h5">{{ $t('Products') }}
      <v-chip
        class="mt-1 mb-2"
        color="primary"
        label
        small
        text-color="white"
      >
        <v-icon
          left
          small
        >fal fa-tag</v-icon>
        {{ this.$route.params.tag }}
      </v-chip>
    </h1>

    <products-table
      :tag="this.$route.params.tag"
      class="mt-4"
      include-search
    />
  </v-container>
</template>

<script>
import Vue from 'vue'
import ProductsTable from '@/components/products/ProductsTable'

export default {
  metaInfo () {
    return { title: this.pageTitle }
  },

  components: {
    ProductsTable
  },

  data: () => ({
    pageTitle: Vue.i18n.translate('Products')
  })
}
</script>



// WEBPACK FOOTER //
// src/views/products/Tag.vue